<div class="devices-enrollment-key">
  <div class="enrollment-content-wrapper">
    <div class="download-installer-section">
      <span class="step-number">1.</span>
      <span class="step-description">
        {{ 'integrationPage.authDescriptions.devicesDownloadInstallerDescription' | labelsProvider }}
      </span>
      <p-dropdown
        [(ngModel)]="selectedPlatform"
        [options]="platformOptions"
        [placeholder]="'integrationPage.authDescriptions.devicesDownloadInstallerButton' | labelsProvider"
        (onChange)="onPlatformSelect()"
        styleClass="download-installer-dropdown"
        [showClear]="false"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          @if (selectedOption) {
            <div class="dropdown-item-content">
              <i class="pi pi-download"></i>
              <span>{{ selectedOption.label }}</span>
            </div>
          }
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <div class="dropdown-option-content">
            <span>{{ option.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="enrollment-key-description">
      <span class="step-number">2.</span>
      {{ 'integrationPage.authDescriptions.devicesEnrollmentKeyDescription' | labelsProvider }}
    </div>

    <div class="enrollment-key-field">
      <div class="enrollment-key-label">
        {{ 'integrationPage.authDetails.endpointEnrollmentKeyFieldKey' | labelsProvider }}
      </div>
      <div class="enrollment-key-input-row">
        <div class="enrollment-key-input-wrapper">
          <input type="text" [value]="displayKey" readonly class="enrollment-key-input" />
          <button type="button" class="eye-button-inside" (click)="toggleKeyVisibility()">
            <img
              [src]="isKeyVisible() ? 'assets/images/common/hide.svg' : 'assets/images/common/view.svg'"
              alt="Toggle visibility"
            />
          </button>
        </div>
        <div class="copy-button-wrapper">
          @if (showCopyNotification()) {
            <div class="copy-popup" @fadeInOut (@fadeInOut.done)="showCopyNotification.set(false)">Copied!</div>
          }
          <button type="button" class="action-button copy-button" (click)="copyToClipboard()">
            <img src="assets/images/common/copy.svg" alt="Copy" />
            <span>Copy</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
